import { useEffect, useState, useCallback } from "react";
import { getUserModules } from "../../api/userService";
export const useUserModules = (userId, officeId, open) => {
    const [modules, setModules] = useState({
        data: [],
        pagination: { page: 1, limit: 1000, totalPages: 1, total: 0 },
        sort: null,
        search: null,
    });
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");

    const fetchData = useCallback(
        async (page = 1, limit = 1000, append = false, search = searchTerm) => {
            setLoading(true);
            try {
              let response = await getUserModules(userId, officeId);
              setModules(prev => {
              if (append) {
                  return {
                  ...response,
                  data: [...(prev.data || []), ...response.data],
                  };
              }
              // 🔑 Reset pagination when not appending (fresh search or initial load)
              return {
                  ...response,
                  pagination: { ...response.pagination, page }, 
              };
              });
              return response;
            } catch (err) {
                console.error("Failed to fetch invoices:", err);
            } finally {
                setLoading(false);
            }
        },
        [searchTerm]
    );

    useEffect(() => {
      if (open) fetchData(1, 1000, false, searchTerm);
    }, [fetchData, searchTerm, open]);

    // 🔎 Called by SearchBox
    const searchFunction = async (page, keywords) => {
        setSearchTerm(keywords);
        // Reset results and pagination when searching
        await fetchData(page, modules.pagination.limit, false, keywords);
    };

    const resetParent = async () => {
        setSearchTerm("");
        await fetchData(1, 1000, false, "");
    };

    return { modules, loading, searchFunction, resetParent };
};